import React, { useContext, useEffect, useState } from "react";
import "./App.css";
import MainLayout from "./layouts/MainLayout";
import { HashRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import HomePage from "./pages/HomePage";
import Clients from "./pages/Clients";
import Stores from "./pages/Stores";
import Fournisseurs from "./pages/Fournisseurs";
import AccountSettings from "./pages/AccountSettings";
import { AppProvider, AppContext } from "./contexts/AppContext";
import Login from "./pages/Login";
import { useAuth } from "./hooks/useAuth";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import PartnerInfo from "./pages/PartnerInfo";

const AppContent = () => {
    const { state, dispatch } = useContext(AppContext);
    const location = useLocation();
    useAuth(dispatch);

    // Check if the user is logged in
    const isUserLoggedIn = !!state.user;

    return (
        <Routes>
            <Route
                path="/login"
                element={isUserLoggedIn ? <Navigate to="/home" /> : <Login />}
            />
            <Route
                path="/*"
                element={isUserLoggedIn ? (
                    <MainLayout>
                        <Routes>
                            <Route path="contacts/clients" element={<Clients />} />
                            <Route path="contacts/fournisseurs" element={<Fournisseurs />} />
                            <Route path="/home" element={<HomePage />} />
                            <Route path="/stores" element={<Stores />} />
                            <Route path="partner-info/:id" element={<PartnerInfo />} />
                            <Route path="account-settings" element={<AccountSettings />} />
                        </Routes>
                    </MainLayout>
                ) : (
                    <Navigate to="/login" state={{ from: location }} replace />
                )}
            />
        </Routes>
    );
};

const App = () => {
    const [primaryColor, setPrimaryColor] = useState("#6e4cc5"); // Default primary color
    const [secondaryColor, setSecondaryColor] = useState("#9c27b0"); // Default secondary color

    const theme = createTheme({
        palette: {
            primary: {
                main: primaryColor,
            },
            secondary: {
                main: secondaryColor,
            },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <QueryClientProvider client={new QueryClient()}>
                <AppProvider>
                    <Router>
                        <AppContent />
                    </Router>
                </AppProvider>
            </QueryClientProvider>
        </ThemeProvider>
    );
};

export default App;